import React from "react";
import XmlDealer from "../components/UI/reusable-components/XmlDealer/XmlDealer";

export const XmlDealerPage = () => {
    return (
        <div>
            <XmlDealer />
        </div>
    )
}